KXL.module('Common.Utils.Dom', function (Dom, KXL, Backbone, Marionette, $, _) {

	Dom.isolatedScroll = function (el) {
		// Do Nothing for now.
	};
});
